/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntentRead } from '../models/IntentRead';
import type { IntentWriteSerializerWithRepr } from '../models/IntentWriteSerializerWithRepr';
import type { PaginatedIntentListList } from '../models/PaginatedIntentListList';
import type { PaginatedIntentWriteSerializerWithReprList } from '../models/PaginatedIntentWriteSerializerWithReprList';
import type { PatchedIntentWriteSerializerWithRepr } from '../models/PatchedIntentWriteSerializerWithRepr';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IntentsService {
    /**
     * @returns PaginatedIntentListList
     * @throws ApiError
     */
    public static intentsList({
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedIntentListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/intents/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
        });
    }
    /**
     * @returns IntentWriteSerializerWithRepr
     * @throws ApiError
     */
    public static intentsCreate({
        requestBody,
    }: {
        requestBody: IntentWriteSerializerWithRepr,
    }): CancelablePromise<IntentWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/intents/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedIntentWriteSerializerWithReprList
     * @throws ApiError
     */
    public static intentBulkUpdate({
        requestBody,
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<IntentWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedIntentWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/intents/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedIntentWriteSerializerWithReprList
     * @throws ApiError
     */
    public static intentBulkPartialUpdate({
        requestBody,
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<IntentWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedIntentWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/intents/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static intentBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/intents/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns IntentRead
     * @throws ApiError
     */
    public static intentsRetrieve({
        id,
        excludeFields,
        fields,
        name,
        readDepth,
    }: {
        /**
         * A unique integer value identifying this intent.
         */
        id: number,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        name?: Array<string>,
        readDepth?: number,
    }): CancelablePromise<IntentRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/intents/{id}/',
            path: {
                'id': id,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'name': name,
                'read_depth': readDepth,
            },
        });
    }
    /**
     * @returns IntentWriteSerializerWithRepr
     * @throws ApiError
     */
    public static intentsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this intent.
         */
        id: number,
        requestBody: IntentWriteSerializerWithRepr,
    }): CancelablePromise<IntentWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/intents/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns IntentWriteSerializerWithRepr
     * @throws ApiError
     */
    public static intentsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this intent.
         */
        id: number,
        requestBody?: PatchedIntentWriteSerializerWithRepr,
    }): CancelablePromise<IntentWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/intents/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static intentsDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this intent.
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/intents/{id}/',
            path: {
                'id': id,
            },
        });
    }
}
